import React from "react";
import {
  Avatar,
  Box,
  Button,
  Flex,
  Heading,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { Link, NavLink } from "react-router-dom";
import "../Components/navbar.module.css";
import resume from "../Images/Aslam-Mahetar-Resume.pdf";
import { DragHandleIcon } from "@chakra-ui/icons";

const Navbar = () => {
  return (
    <Box
      id="nav-menu"
      w={"100%"}
      bgColor={"#89CFF0"}
      p={"2"}
      position={"fixed"}
      zIndex={"999"}
      top={"0"}
    >
      <Flex alignItems={"center"} m={"auto"}>
        <Heading as={"h2"} size={"lg"} p={"3"}>
          Aslam
        </Heading>
        <Flex
          // border={"solid black"}
          display={{
            base: "none",
            sm: "none",
            md: "none",
            lg: "flex",
            xl: "flex",
            "2xl": "flex",
          }}
          mt={"2"}
          ml={"10px"}
          justifyContent={"space-around"}
          width={"30%"}
          fontSize={"md"}
        >
          <a className={"nav-link about"} href={"#about"}>
            About
          </a>
          <a href="#skills" className={"nav-link skills"}>
            Skills
          </a>
          <a href={"#projects"} className={"nav-link projects"}>
            Project
          </a>
          <a href={"#contact"} className={"nav-link contact"}>
            Contact
          </a>
          <a href={"#testimonials"} className={"nav-link testimonials"}>
            Testimonials
          </a>
          <NavLink className={"nav-link home"} to={"/home"}></NavLink>
        </Flex>
        <Menu>
          <MenuButton
            mr={"25px"}
            as={Button}
            display={{
              base: "flex",
              sm: "flex",
              md: "flex",
              lg: "none",
              xl: "none",
            }}
            justifyContent={"center"}
          >
            <DragHandleIcon />
          </MenuButton>
          <MenuList>
            <MenuItem>
              <a className={"nav-link about"} href={"#about"}>
                <MenuItem w={"100%"}>About</MenuItem>
              </a>
            </MenuItem>
            <MenuItem>
              <a href="#skills" className={"nav-link skills"}>
                <MenuItem w={"100%"}>Skills</MenuItem>
              </a>
            </MenuItem>
            <MenuItem>
              <a href={"#projects"} className={"nav-link projects"}>
                <MenuItem w={"100%"}>Project</MenuItem>
              </a>
            </MenuItem>
            <MenuItem>
              <a href={"#contact"} className={"nav-link contact"}>
                <MenuItem w={"100%"}>Contact</MenuItem>
              </a>
            </MenuItem>
            <MenuItem>
              <a href={"#testimonials"} className={"nav-link testimonials"}>
                <MenuItem w={"100%"}>Testimonials</MenuItem>
              </a>
            </MenuItem>
          </MenuList>
        </Menu>

        <Spacer
          display={{ base: "none", sm: "none", md: "block", lg: "block" }}
        />
        <Flex alignItems={"center"} ml={"25px"}>
          <Button
            className={"nav-link resume"}
            id="resume-button-1"
            mr={"5"}
            onClick={() =>
              window.open(
                "https://drive.google.com/file/d/1ydk5O-TOfKJSXTVDgWYc9kNj1fgC4RIB/view?usp=drive_link"
              )
            }
          >
            <a
              href={resume}
              download={"Aslam-M-Mahetar Resume"}
              id="resume-link-1"
            >
              Resume
            </a>
          </Button>
          <Wrap mr={"100px"}>
            <Menu>
              <MenuButton>
                <WrapItem>
                  <Avatar
                    name="Aslam Mahetar"
                    src="https://avatars.githubusercontent.com/u/115460260?s=400&u=33aed1fe3134a969683fdfdef5d61e8282c31005&v=4"
                  />
                </WrapItem>
              </MenuButton>
              <MenuList>
                <Link
                  to={"https://www.linkedin.com/in/aslam-m-mahetar-b2081824b/"}
                  target="_blanck"
                >
                  <MenuItem>Linked In</MenuItem>
                </Link>
                <Link to={"https://github.com/aslammmahetar"} target="_blanck">
                  <MenuItem>Github</MenuItem>
                </Link>
              </MenuList>
            </Menu>
          </Wrap>
        </Flex>
      </Flex>
    </Box>
  );
};

export default Navbar;
